import de from './de';
import en from './en';
import fi from './fi';
import fr from './fr';
import no from './no';
import sv from './sv';

export default { en, sv, no, de, fr, fi };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/i18n/index.ts